import React from "react";
import "./Modal.css";
import Button from "../ui/Button";
import { AiOutlineCloseCircle } from "react-icons/ai";

function Modal({ component, modalState, close, type }) {
  return (
    <div className={`${modalState ? "modal-wrapper show" : "modal-wrapper"}`}>
      <div
        className={`modal md:w-10/12 lg:w-4/5 ${
          type === "autoModal" ? "autoHeight" : "modalHeight"
        }`}
      >
        <div className="flex justify-between">
          <span></span>
          <Button
            icon={
              <AiOutlineCloseCircle className="mt-2 text-2xl text-gray-600 hover:scale-125 transition transform duration-300 ease-out" />
            }
            purpose={close}
          />
        </div>
        {component}
      </div>
    </div>
  );
}

export default Modal;
